import React from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useEventTracking } from '@services/statsig';

import CustomButton from '../../styles/CustomButtons';
import { JotPsychWordmarkLogo } from '../Icons/Logo';

export const NavBranding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navigation: navigationMetrics } = useEventTracking();

  return (
    <Box
      color="primary"
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        minWidth: '120px',
      }}
    >
      <CustomButton
        onClick={() => {
          // Track logo click navigation
          navigationMetrics.clicked({
            menu_item: 'logo',
            source_path: location.pathname,
            destination_path: '/',
            is_dropdown: false,
          });
          navigate('/');
        }}
        size="large"
        aria-label="logo-home-button"
      >
        <JotPsychWordmarkLogo size={100} />
      </CustomButton>
    </Box>
  );
};
